import React from 'react';
import { ASSETS_BASE_URL } from '../../../lib/constants';
import { UserDtoType } from '../../../types/dto/UserDtoType';

type UserAvatarProps = {
  className?: string,
  user?: UserDtoType,
  avatar?: string
};

export function UserAvatar({ user, avatar, className }: UserAvatarProps) {
  return (
    <div
      className={`w-10 h-10 bg-cover rounded-full ${className || ''}`}
      style={{
        backgroundImage: `url('${ASSETS_BASE_URL}${avatar || user?.avatar || 'user-avatar/default.jpg'}')`
      }}
      />
  );
}